import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';

import { getCampaignId } from '../../redux/modules/campaignLandingPage';
import { getQueryParams } from '../../helpers/commonHelper';
import { StyledVpInfoBanner } from './styles';
import { VpIcon } from '../../vp-ui';

const LandingPagePreviewBanner = ({ campaignId }) => {
  const queryParams = getQueryParams(window.location.search);

  const publishedCampaignUrl = window.location.origin + window.location.pathname;

  if (!campaignId || !queryParams.preview) return <></>;

  return (
    <StyledVpInfoBanner>
      <VpIcon icon="Info" />
      <Typography variant="body2">
        This is a preview. Publish your campaign and share{' '}
        <a href={publishedCampaignUrl}>this link</a> to get responses.
      </Typography>
    </StyledVpInfoBanner>
  );
};

LandingPagePreviewBanner.propTypes = {
  campaignId: PropTypes.number
};

const mapStateToProps = (state) => ({
  campaignId: getCampaignId(state)
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPagePreviewBanner);



// WEBPACK FOOTER //
// ./src/containers/CampaignLandingPage/LandingPagePreviewBanner.jsx